import { ComponentType, GetPageComponentItemViewModel } from '@/types/cml-api';
import { sendCtaClickEvent } from '@/features/analytics/datalayer/datalayer';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import { IconArrowSquareLeft } from '@/features/icons';
import LazyImage from '@/features/image/lazy-image';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Webengage } from '@/features/webengage';
import { cn } from '@/utils/cn';
import { DataLayerProps, IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps, GetPageComponentItemViewModel, DataLayerProps {}
export default function TestimonialItem({
  id,
  isLazy,
  index,
  brandDesktopImageUrl,
  brandMobileImageUrl,
  desktopImageUrl,
  link,
  mobileImageUrl,
  text,
  title,
  currentSlide,
  componentId,
  sortKey
}: Props) {
  const isActiveItem = currentSlide === Number(index) - 1;
  const {
    isMobile
  } = useMobileDetect();
  const handleClick = () => {
    sendCtaClickEvent({
      componentId: componentId ?? '',
      elementType: ComponentType.Testimonial,
      elementName: sortKey,
      itemID: id ?? '',
      elementIndex: index ?? 0,
      destinationUrl: link ?? '',
      ImageUrl: isMobile ? mobileImageUrl : desktopImageUrl
    });
    Webengage.trackCtaAction({
      component_id: componentId ?? '',
      banner_type: ComponentType.Testimonial,
      banner_name: sortKey ?? '',
      item_id: id || '',
      banner_index: index?.toString() || '0',
      url_destination: link || '',
      image_url: (isMobile ? mobileImageUrl : desktopImageUrl) ?? ''
    });
  };
  if (!mobileImageUrl || !title) return null;
  return <AppNextLink href={link || ''} prefetch={false} className='keen-slider__slide min-w-80 lg:min-w-[420px]' onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="TestimonialItem" data-sentry-source-file="testimonial-item.tsx">
            <div className={cn('flex transform-gpu flex-col overflow-hidden rounded-lg border border-border-gray-light bg-white p-2 transition-transform duration-200 lg:h-[216px] lg:p-2.5', isMobile && (isActiveItem ? 'scale-y-100' : 'scale-y-90'))}>
                <div className='flex h-[28px] items-center justify-between lg:h-[36px]'>
                    <p className='text-caption-12 font-medium text-text-darkGray lg:text-body-16'>
                        <span className='text-primary-main'>به خاطر خودت</span>،‌ چون{' '}
                        <span className='text-primary-main'>نظرت</span> مهمه...
                    </p>
                    <picture data-sentry-element="picture" data-sentry-source-file="testimonial-item.tsx">
                        <source media='(min-height: 28px)' srcSet={brandDesktopImageUrl || ''} />
                        <img src={brandMobileImageUrl ?? ''} alt={title} className='max-h-[28px] w-full object-contain lg:max-h-[36px]' loading={isLazy ? 'lazy' : undefined} />
                    </picture>
                </div>
                <div className='mt-1 flex h-full flex-1 items-start gap-1 lg:mt-1.5'>
                    <picture data-sentry-element="picture" data-sentry-source-file="testimonial-item.tsx">
                        <source media='(min-height: 92px)' srcSet={desktopImageUrl || ''} />

                        <LazyImage src={mobileImageUrl} alt={title} className='h-[92px] min-w-[92px] lg:h-28 lg:min-w-28' loaderClassName='h-[92px] lg:h-28 w-[92px] lg:w-28' isLazy={isLazy} data-sentry-element="LazyImage" data-sentry-source-file="testimonial-item.tsx" />
                    </picture>

                    <div className='flex flex-col gap-1 lg:gap-1.5'>
                        <span className='line-clamp-1 text-caption-12 font-medium text-text-darkGray lg:text-body-16'>
                            {title}
                        </span>
                        <p className='line-clamp-3 break-words text-caption-12 [overflow-wrap:anywhere] lg:text-body-16 lg:leading-7'>
                            <strong className='text-body-16'>&ldquo;</strong>
                            {text}
                            <strong className='text-body-16'>&rdquo;</strong>
                        </p>
                    </div>
                </div>
                <Button icon={{
        element: <IconArrowSquareLeft className='h-5 w-5 text-primary-main' />,
        position: 'left'
      }} size='medium' graphicStyle='text' className='mt-1 flex items-center justify-end p-1 lg:mt-1.5 lg:px-4 lg:py-2' data-sentry-element="Button" data-sentry-source-file="testimonial-item.tsx">
                    <span className='text-caption-12 font-medium text-black lg:text-body-14'>مشاهده</span>
                </Button>
            </div>
        </AppNextLink>;
}